module.exports = __webpack_public_path__ + "img/SOKAL-SRS-112321-DealerDraftMazda-Modern3.9ab1d6a9.jpeg";